import React from 'react';

/**
 * Top of every admin page: title, one line saying what the page is for, and
 * the page-level actions on the right. Anything passed as children (tabs, a
 * notice) renders underneath.
 */
const PageHeader = ({ title, subtitle, tags, extra, children }) => (
  <div className="page-head">
    <div className="page-head__main">
      <div className="page-head__titles">
        <h1 className="page-head__title">
          {title}
          {tags ? <span className="page-head__tags">{tags}</span> : null}
        </h1>
        {subtitle ? <p className="page-head__subtitle">{subtitle}</p> : null}
      </div>
      {extra ? <div className="page-head__extra">{extra}</div> : null}
    </div>
    {children}
  </div>
);

export default PageHeader;
